/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

export default function FeaturedNewsGrid({ news }) {

    const firstCategory = Object.keys(news)[0];

    if (!firstCategory) return null;

    const featured = news[firstCategory]?.slice(0, 4);

    if (!featured || featured.length === 0) return null;

    return (

        <div className="
            grid
            grid-cols-1
            lg:grid-cols-3
            gap-6
            mb-10
        ">

            {/* Main Featured Story */}

            <a
                href={featured[0]?.url}
                target="_blank"
                rel="noreferrer"
                className="
                    lg:col-span-2
                    group
                    bg-gradient-to-br
                    from-zinc-900
                    to-zinc-950
                    border
                    border-zinc-800
                    rounded-3xl
                    p-8
                    min-h-[420px]
                    flex
                    flex-col
                    justify-between
                    hover:border-emerald-500
                    transition-all
                    duration-300
                "
            >

                <div>

                    <div className="
                        inline-flex
                        items-center
                        gap-2
                        px-3
                        py-1
                        rounded-full
                        bg-emerald-500/10
                        text-emerald-400
                        text-xs
                        font-semibold
                        tracking-wide
                        mb-6
                    ">
                        FEATURED STORY
                    </div>

                    <h2 className="
                        text-3xl
                        lg:text-4xl
                        font-bold
                        text-white
                        leading-tight
                        mb-6
                        group-hover:text-emerald-400
                        transition-colors
                    ">
                        {featured[0]?.title}
                    </h2>

                    <p className="
                        text-zinc-300
                        text-lg
                        leading-relaxed
                        max-w-3xl
                    ">
                        {featured[0]?.description}
                    </p>

                </div>

                <div className="
                    flex
                    items-center
                    justify-between
                    mt-10
                    pt-6
                    border-t
                    border-zinc-800
                ">

                    <span className="
                        text-sm
                        text-zinc-400
                    ">
                        {featured[0]?.date}
                    </span>

                    <span className="
                        text-emerald-400
                        font-medium
                        group-hover:translate-x-1
                        transition-transform
                    ">
                        Read Full Story →
                    </span>

                </div>

            </a>

            {/* Right Side Stories */}

            <div className="space-y-6">

                {featured.slice(1).map((item, idx) => (

                    <a
                        key={idx}
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                        className="
                            group
                            block
                            bg-zinc-900
                            border
                            border-zinc-800
                            rounded-2xl
                            p-5
                            hover:border-emerald-500
                            transition-all
                            duration-300
                        "
                    >

                        <div className="
                            text-xs
                            text-zinc-500
                            mb-3
                        ">
                            {item.date}
                        </div>

                        <h3 className="
                            text-lg
                            font-semibold
                            text-white
                            leading-snug
                            mb-3
                            group-hover:text-emerald-400
                            transition-colors
                            line-clamp-3
                        ">
                            {item.title}
                        </h3>

                        <p className="
                            text-sm
                            text-zinc-400
                            leading-relaxed
                            line-clamp-3
                        ">
                            {item.description}
                        </p>

                    </a>

                ))}

            </div>

        </div>

    );
}